import { createContext, useContext } from 'react';

const LoginModalLocalInfoContext = createContext();

export const LoginModalLocalInfoContextProvider =
  LoginModalLocalInfoContext.Provider;
export const LoginModalLocalInfo = () => useContext(LoginModalLocalInfoContext);
